import gsap from 'gsap'

export default {
  init() {
    const openTrigger = document.querySelector('#ved-overlay-open')
    if (!openTrigger) return
    const panel = document.getElementById('ved-sticky-panel')
    const wrapper = document.getElementById('ved-sticky-wrapper')

    if (!panel || !wrapper) return
    const tl = gsap.timeline({ paused: true })
    tl.fromTo(
      panel,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 0.6,
      }
    )

    if (wrapper.classList.contains('is-fullscreen')) {
      wrapper.style.display = 'block'
      tl.progress(1)
      document.body.classList.add('overflow-hidden')
      document.body.style.height = '100vh'
    }

    openTrigger.addEventListener('click', (e) => {
      e.preventDefault()
      wrapper.style.display = 'block'
      document.body.classList.add('overflow-hidden')
      document.body.style.height = '100vh'
      tl.play()
    })

    const closeTrigger = document.querySelector('#ved-overlay-close')

    closeTrigger?.addEventListener('click', () => {
      tl.eventCallback('onReverseComplete', () => {
        wrapper.style.display = 'none'
        document.body.classList.remove('overflow-hidden')
        document.body.style.height = ''
      })

      tl.reverse()
    })

    // const scrollUp = panel.querySelector('#scroll-up')
    // const scrollDown = panel.querySelector('#scroll-down')

    // Sticky keeps the panel flush at top:0 only while it's pinned/fully in
    // view; outside that range its top is either positive (not reached yet)
    // or negative (already scrolled past).
    // function isPanelCentered() {
    //   return Math.abs(panel.getBoundingClientRect().top) < 1
    // }

    // function centerPanel() {
    //   window.scrollTo({
    //     top: window.scrollY + panel.getBoundingClientRect().top,
    //     behavior: 'smooth',
    //   })
    // }

    // function exitAbove() {
    //   const target = wrapper || panel
    //   window.scrollTo({
    //     top:
    //       target.getBoundingClientRect().top +
    //       window.scrollY -
    //       window.innerHeight,
    //     behavior: 'smooth',
    //   })
    // }

    // function exitBelow() {
    //   const target = wrapper || panel
    //   window.scrollTo({
    //     top: target.getBoundingClientRect().bottom + window.scrollY,
    //     behavior: 'smooth',
    //   })
    // }

    // scrollUp?.addEventListener('click', () => {
    //   if (isPanelCentered()) exitAbove()
    //   else centerPanel()
    // })
    // scrollDown?.addEventListener('click', () => {
    //   if (isPanelCentered()) exitBelow()
    //   else centerPanel()
    // })
  },
}
